import { render, staticRenderFns } from "./arquivoRemessa.vue?vue&type=template&id=16928ef4&scoped=true"
import script from "./arquivoRemessa.vue?vue&type=script&lang=js"
export * from "./arquivoRemessa.vue?vue&type=script&lang=js"
import style0 from "./arquivoRemessa.vue?vue&type=style&index=0&id=16928ef4&prod&scoped=true&lang=css"
import style1 from "./arquivoRemessa.vue?vue&type=style&index=1&id=16928ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16928ef4",
  null
  
)

export default component.exports